/** Dias antes do vencimento do seguro em que a renovação pode ser iniciada. */
export const DIAS_JANELA_RENOVACAO = 30;

export function calcularDiasAteVencimento(dataFim: string | undefined | null): number | null {
  if (!dataFim) return null;

  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  const vencimento = new Date(dataFim);
  vencimento.setHours(0, 0, 0, 0);

  const diferencaMs = vencimento.getTime() - hoje.getTime();
  return Math.ceil(diferencaMs / (1000 * 60 * 60 * 24));
}

/** Renovação liberada nos últimos 30 dias (inclui vencidos). */
export function podeIniciarRenovacao(dataFim: string | undefined | null): boolean {
  const dias = calcularDiasAteVencimento(dataFim);
  if (dias === null) return false;
  return dias <= DIAS_JANELA_RENOVACAO;
}

export function mensagemRenovacaoIndisponivel(dias: number | null): string {
  if (dias === null) {
    return "Renovação indisponível: contrato sem data de vencimento.";
  }
  if (dias > DIAS_JANELA_RENOVACAO) {
    return `Renovação disponível apenas nos últimos ${DIAS_JANELA_RENOVACAO} dias antes do vencimento (faltam ${dias} dias).`;
  }
  return "";
}
